export interface Article {
  id: string;
  title: string;
  excerpt: string;
  image: string;
  tag: string;
  date: string;
  read: string;
}

export const articles: Article[] = [
  {
    id: "story-first",
    title: "为什么高分漫画都在认真讲故事",
    excerpt: "在香香漫画高分排行榜中常年霸榜的作品，几乎都有一个共同点：扎实的剧情内核。本期我们聊聊，究竟是什么让一部漫画从好看升级为神作。",
    image: "https://readdy.ai/api/search-image?query=Illustration%20of%20an%20open%20storybook%20glowing%20with%20warm%20light%20and%20tiny%20manga%20characters%20stepping%20out%2C%20warm%20coral%20and%20gold%20palette%2C%20editorial%20illustration%20style%2C%20high%20detail%2C%20whimsical%20and%20inviting%20composition&width=800&height=500&seq=article-01&orientation=landscape",
    tag: "深度解读",
    date: "08-15",
    read: "12 分钟",
  },
  {
    id: "new-2026",
    title: "2026 上半年必看新作盘点",
    excerpt: "今年上半年涌现了大量口碑爆棚的新作品。我们综合香香漫画的高分与热度数据，为你精挑细选了 8 部不容错过的优质新作。",
    image: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20calendar%20with%20comic%20panels%20and%20colorful%20new%20manga%20covers%20popping%20out%2C%20warm%20festive%20palette%2C%20editorial%20illustration%2C%20high%20detail%2C%20playful%20composition&width=800&height=500&seq=article-02&orientation=landscape",
    tag: "新作推荐",
    date: "08-10",
    read: "10 分钟",
  },
  {
    id: "healing-picks",
    title: "治愈系漫画为什么这么上头",
    excerpt: "忙碌一天后，一部温柔的治愈漫画往往比什么都管用。从香香漫画治愈分类的高分作品出发，拆解治愈系作品的魔力所在。",
    image: "https://readdy.ai/api/search-image?query=Soft%20cozy%20illustration%20of%20a%20warm%20cup%20of%20tea%20with%20a%20curled%20up%20cat%20and%20warm%20light%2C%20cream%20and%20coral%20palette%2C%20soothing%20editorial%20art%2C%20high%20detail%2C%20gentle%20calm%20mood&width=800&height=500&seq=article-03&orientation=landscape",
    tag: "类型解读",
    date: "08-06",
    read: "8 分钟",
  },
  {
    id: "hidden-gems",
    title: "冷门高分宝藏挖掘：小众漫画推荐",
    excerpt: "高分不等于热门。在香香漫画的榜单深处，藏着许多评分极高却少有人知的宝藏作品，本期带你把它们一一挖出来。",
    image: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20treasure%20chest%20overflowing%20with%20glowing%20comic%20pages%20and%20sparkling%20gems%2C%20warm%20gold%20and%20coral%20palette%2C%20editorial%20illustration%2C%20high%20detail%2C%20magical%20composition&width=800&height=500&seq=article-04&orientation=landscape",
    tag: "宝藏挖掘",
    date: "08-02",
    read: "15 分钟",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "香香漫画的推荐是免费的吗？",
    a: "是的，香香漫画的精选推荐、高分排行和编辑专题全部免费浏览，您无需付费即可查看榜单与推荐内容，放心点开即看。",
  },
  {
    q: "高分排行榜多久更新一次？",
    a: "排行榜分为周榜、月榜与总榜。周榜每周更新，月榜每月初刷新，总榜则会随着用户收藏与评分的变化实时动态调整，始终反映真实热度。",
  },
  {
    q: "如何快速找到喜欢的漫画类型？",
    a: "您可以通过顶部的漫画分类板块，按热血、奇幻、校园、悬疑、治愈、科幻等类型快速筛选，也可以借助站内搜索直接查找作品名称。",
  },
  {
    q: "新作更新提示在哪里查看？",
    a: "首页新作速递板块会展示最近上架与最新更新的作品，标注更新话数与更新时间，方便您第一时间追更心仪的作品。",
  },
  {
    q: "可以收藏漫画并追踪更新吗？",
    a: "可以。每部作品都提供收藏与评分入口，收藏后的作品会进入您的个人清单，后续更新时会有提醒，方便您持续追更。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  rating: number;
  color: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "洛洛酱",
    role: "漫画发烧友 · 收藏 300+",
    text: "自从用了香香漫画，再也不用到处问人有什么好看了。高分榜单特别靠谱，推荐的每部都是心头好，治愈分类直接封神。",
    rating: 5,
    color: "bg-primary-500",
  },
  {
    name: "阿哲",
    role: "悬疑爱好者",
    text: "雾隐少年就是在这里发现的，烧脑程度绝了。编辑的专题解读也写得很有深度，看漫画还能顺便补不少冷知识。",
    rating: 5,
    color: "bg-accent-500",
  },
  {
    name: "甜甜圈",
    role: "新手入坑",
    text: "刚入坑漫画不知道从哪看起，香香漫画的编辑精选帮了大忙，从热门到冷门都安排得明明白白，追更也不迷路。",
    rating: 4,
    color: "bg-secondary-500",
  },
  {
    name: "键盘侠小美",
    role: "追更十年老粉",
    text: "新作速递更新很快，当天更新的作品当天就能看到进度。排行榜的评分也很真实，和我的口味高度一致，强烈安利。",
    rating: 5,
    color: "bg-primary-700",
  },
];